<div class="wccard px-3 py-3 mb-1">
    <app-talent-insights-ai *ngIf="overviewDataForAISummary" [jobDemandCount]="hasJobDemand" [requestaidata]="overviewDataForAISummary" [insightstabname]="'overview'"
        [totalcount]="totalResultCount"></app-talent-insights-ai>
</div>

<div class="wccard p-3">
    <div class="summarybox mb-4">
        <div class="row">
            <div class="col borderRight">
                <div class="loader text-center" *ngIf="!reportOverViewLoaders.isProfessionalCountCalled" style="height: 8vh;">
                    <img src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
                </div>
                <div *ngIf="reportOverViewLoaders.isProfessionalCountCalled" class="pointer" (click)="handelRedirection('total', professionalsCount)">
                    <p class="f-18 font-weight-600 mb-0" matTooltip="Total Talent Count : {{professionalsCount}}"
                  [matTooltipClass]="{ 'red-tooltip': true }"><span>{{formatNumberToIndianFormat(professionalsCount)}}</span></p>
                    <p class="f-12 text-9696">Talent Count <i class="fa-regular fa-info-circle" matTooltip="The total number of professionals within the talentpool." [matTooltipClass]="{ 'red-tooltip text-black': true }"></i></p>
                </div>
            </div>
            <div class="col borderRight">
                <div class="loader text-center" *ngIf="!reportOverViewLoaders.isChangedJobCountCalled" style="height: 8vh;">
                    <img src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
                </div>
                <div *ngIf="reportOverViewLoaders.isChangedJobCountCalled">
                    <p class="f-18 font-weight-600 mb-0"><span>{{formatNumberToIndianFormat(changedJobCount)}}</span></p>
                    <p class="f-12 text-9696">Changed Jobs(past 1yr)</p>
                </div>
            </div>
            <!-- <div class="col borderRight">
                <div class="loader text-center" *ngIf="!reportOverViewLoaders.isLikeToMoveCalled" style="height: 8vh;">
                    <img src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
                </div>
                <div *ngIf="reportOverViewLoaders.isLikeToMoveCalled">
                    <p class="f-26 font-weight-600 mb-0"><span>{{formatNumberToIndianFormat(likeToMoveCount)}}</span></p>
                    <p class="f-14 text-9696">Likely to Move</p>
                </div>
            </div> -->

            <div class="col borderRight">
                <div class="loader text-center" *ngIf="!reportOverViewLoaders.isMedianTanureCountCalled" style="height: 8vh;">
                    <img src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
                </div>
                <div *ngIf="reportOverViewLoaders.isMedianTanureCountCalled">
                    <p class="f-18 font-weight-600 mb-0"><span [innerHTML]="getFormattedTenureForMatrix(medianTanuresCount)"></span></p>
                    <p class="f-12 text-9696">Median Tenure <i class="fa-regular fa-info-circle" matTooltip="Median Tenure of the talent" [matTooltipClass]="{ 'red-tooltip text-black': true }"></i></p>
                </div>
            </div>

            <!-- <div class="col text-center borderRight">
                <div class="text-center">
                    <div class="loader text-center" *ngIf="!reportOverViewLoaders.isGenderDiversityCalled" style="height: 8vh;">
                        <img src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
                    </div>
                    <div class="d-flex align-items-center" *ngIf="reportOverViewLoaders.isGenderDiversityCalled">
                        <span class="fa-person-icon"><i class="fa-solid fa-person"></i></span>
                            <span class="f-24 font-weight-600 mb-0">{{genderDiversityMale ? genderDiversityMale: '0'}}</span>
                            <span class="gender-persent-icon mr-1">%</span>
                            <span class="vectordiv mr-1">|</span>
                            <span class="fa-person-icon ml-1"><i class="fa-solid fa-person-dress"></i></span>
                            <p class="f-24 font-weight-600 mb-0">{{genderDiversityFemale ? genderDiversityFemale: '0'}}</p>
                        <span class="gender-persent-icon">%</span>
                    </div>

                    <p class="f-12 text-9696 text-left">Gender Diversity</p>
                </div>
            </div> -->
               <div class="col borderRight">
                <div class="loader text-center" *ngIf="hasJobDemand" style="height: 8vh;">
                    <img src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
                </div>
                <div *ngIf="!hasJobDemand" [ngbTooltip]="jobdemand">
                    <p class="f-18 font-weight-600 mb-0">
                      <span *ngIf="jobDemandCount && jobDemandCount != 0 && jobDemandCount != '0' && professionalsCount != 0" (click)="hasJobListingAccess && openJoblistSlider()" [class.pointer]="hasJobListingAccess">{{jobDemandCount}}</span>
                      <span *ngIf="!jobDemandCount || professionalsCount == 0" style="font-family: Arial, sans-serif;">&mdash;</span>
                    </p>
                    <p class="f-12 text-9696">Active Job Posts</p>
                    <ng-template #jobdemand>
                      <p class="f-12 font-weight-600 mb-1">About Job Post Metrics</p>
                      <p class="f-12 mb-1">Job post data is sourced directly from company career pages and official employer sites, ensuring high accuracy and active demand.</p>
                      <p class="f-12">Job post and salary metrics are influenced by Job Titles, Skills, Location, Industry, Company, Seniority, and Function. Changes to other filters (e.g., education, gender, experience) do not impact these values.</p>
                    </ng-template>
                </div>
            </div>
               <div class="col borderRight">
                <div class="loader text-center" *ngIf="hasJobDemand" style="height: 8vh;">
                    <img src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
                </div>
                <div *ngIf="!hasJobDemand" [ngbTooltip]="mediansalarytooltip">
                    <p class="f-18 font-weight-600 mb-0" *ngIf="medianSalary && professionalsCount != 0"><span [innerHTML]="medianSalary"></span></p>
                    <p class="f-18 font-weight-600 mb-0" *ngIf="!medianSalary || professionalsCount == 0" style="font-family: Arial, sans-serif;">&mdash;</p>

                    <p class="f-12 text-9696">Salary Range</p>
                      <ng-template #mediansalarytooltip>
                      <p class="f-12 font-weight-600 mb-1">About Salary Estimates</p>
                      <p class="f-12 mb-1">Salary range is based on employer-declared compensation shared in job postings. This reflects market-reported averages and may not capture privately negotiated or undisclosed salary bands.</p>
                      <p class="f-12">Salary and job post metrics are influenced by Job Titles, Skills, Location, Industry, Company, Seniority, and Function. Changes to other filters (e.g., education, gender, experience) do not impact these values.</p>
                    </ng-template>
                </div>
            </div>
        </div>
    </div>
    <div class="mb-8">
        <div class="row">
            <div class="col-10">
                <p class="f-16 font-weight-600 mb-4">How is the talent distributed ?</p>
            </div>
            <div class="col text-right" *ngIf="topLocations?.length>5">
                <a data-testid="auto-app-report-overview-tab-a-1" class="view-skills" routerLink="/report-details/report-location" [queryParams]="queryParams">View  All</a>
            </div>
        </div>
        <div class="row align-items-center">
            <div class="col-7">
                <div id="workCountryChart" [hidden]="!(dataSourceWorkCountry && dataSourceWorkCountry?.length)" *ngIf="reportOverViewLoaders.topLocationsFetched"></div>
                <!-- <div class="loader text-center" *ngIf="!dataSourceWorkCountry?.length"> -->
                <div class="loader text-center" *ngIf="!dataSourceWorkCountry?.length">
                    <img *ngIf="!reportOverViewLoaders.topLocationsFetched" src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
                    <span *ngIf="reportOverViewLoaders.topLocationsFetched">No Data Available</span>
                </div>
            </div>
            <div class="col-md-4">
                <!-- <div class="loader text-center" *ngIf="!topLocations?.length"> -->
                <div class="loader text-center" *ngIf="!topLocations?.length">
                    <img *ngIf="!reportOverViewLoaders.topLocationsFetched" src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
                    <span *ngIf="reportOverViewLoaders.topLocationsFetched">No Data Available</span>
                </div>
                <div class="d-flex flex-column" *ngFor="let location of topLocations.slice(0,5)">
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="text-truncate">{{location.key | titlecase}}</div>
                        <div class=" font-weight-600 pointer" (click)="handelRedirection('location', location.key)">{{location.doc_count | number}}</div>
                    </div>
                    <hr class="HR-seperator-in-card mb-4 mx-0">
                </div>
            </div>
        </div>
    </div>
    <hr class="HR-seperator-in-card mb-4">
    <div class="row">
        <div class="col-8">
            <p class="f-16 font-weight-600 mb-4">Which companies and industries are employing this talent ?</p>
        </div>
        <div class="col-4 text-right">
          <div class="d-flex justify-content-end">
            <a data-testid="auto-app-report-overview-tab-a-2" class="view-skills" *ngIf="currentCompany?.length" routerLink="/report-details/report-company" [queryParams]="queryParams">View  Companies</a>
            <div class="vectordiv ml-3" *ngIf="currentCompany?.length || currentIndustry?.length">|</div>
            <a data-testid="auto-app-report-overview-tab-a-3" class="view-titles" *ngIf="currentIndustry?.length" routerLink="/report-details/report-industries" [queryParams]="queryParams">View Industries</a>
        </div>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <div class="loader text-center" *ngIf="!currentCompany?.length">
                <img *ngIf="!reportOverViewLoaders.companyDataFetched" src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
                <span *ngIf="reportOverViewLoaders.companyDataFetched">No Data Available</span>
            </div>
            <div class="row mb-3" *ngIf="currentCompany?.length">
                <div class="col-md-9 f-12 text-9696">
                    Top Companies
                </div>
                <div class="col f-12 text-9696">
                    Talent Count
                </div>
            </div>
            <div class="row mb-2" *ngFor="let company of currentCompany | slice: 0:5">
                <div class="col-md-9">
                    <div class="d-flex p-2 w-100">
                        <div style="width: 50px; border-right: 1px solid #d4d7dd;">
                            <span class="compnaylogoplaceholder" [ngClass]="{'logobgcolor':!company?.companylogo}">
                            <i class="fas fa-buildings f-12" *ngIf="!company.companylogo" ></i>
                            <img src={{company.companylogo}} alt="company_logo" *ngIf="company.companylogo" >
                            </span>
                        </div>
                        <!-- <div style="margin-left: 24px;" class="d-grid" [matTooltip]="company.key | titlecase" [matTooltipClass]="{ 'red-tooltip text-black': true }">
                            <span class="text-truncate">{{company.key | titlecase}}</span>
                        </div> -->

                        <p class="f-16 icon-color mb-1 f-14 position-relative companyHover ">
                            <span class="" (mouseenter)="getCompanyInfo(company?.key)">
                                <span class="position-relative text-capitalize"
                                    [ngClass]="{'dstooltip pointer':primaryCompanyInformation?.website, companyHover: primaryCompanyInformation?.website}">
                                    <span class="text-truncate">{{company.key | titlecase}}</span>
                                    <span class="dstooltip-content">
                                        <app-hire-company-hover-modal [companyInformation]="primaryCompanyInformation" *ngIf="primaryCompanyInformation"></app-hire-company-hover-modal>
                                    </span>
                                </span>
                            </span>
                        </p>
                    </div>
                </div>
                <div class="col f-14 d-flex align-items-center font-weight-600">
                    <span class="pointer"  (click)="handelRedirection('company', company.key)">{{company.doc_count | number}}</span>
                </div>
            </div>
        </div>
        <div class="col">
            <div class="loader text-center" *ngIf="!currentIndustry?.length">
                <img *ngIf="!reportOverViewLoaders.industryDataFetched" src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
                <span *ngIf="reportOverViewLoaders.industryDataFetched">No Data Available</span>
            </div>
            <div class="row mb-3" *ngIf="currentIndustry?.length">
                <div class="col-md-9 f-12 text-9696">
                    Top Industries
                </div>
                <div class="col f-12 text-9696">
                    Talent Count
                </div>
            </div>

            <div class="row mb-2" *ngFor="let industry of currentIndustry | slice: 0:5">
                <div class="col-md-9">
                    <div class="d-flex p-2 w-100">
                        <div style="width: 50px; border-right: 1px solid #eceff4;">
                            <div class="building-icon bg-gray-new">
                                <i [class]="getIndustryIcon(industry?.key)"></i>
                            </div>
                        </div>
                        <div style="margin-left: 24px;" class="d-grid" [matTooltip]="industry.key | titlecase" [matTooltipClass]="{ 'red-tooltip text-black': true }">
                            <span class="text-truncate">{{industry.key | titlecase}}</span>
                        </div>
                    </div>
                </div>
                <div class="col f-14 d-flex align-items-center font-weight-600">
                    <span class="pointer" (click)="handelRedirection('industry', industry.key)">{{industry.doc_count | number}}</span>
                </div>
            </div>
        </div>
    </div>

    <hr class="HR-seperator-in-card mb-4">
    <div class="row">
        <div class="col-9">
            <p class="f-16 font-weight-600 mb-4">Which schools are producing this talent?</p>
        </div>
        <div class="col-3 text-right">
          <div class="d-flex justify-content-end">
            <a data-testid="auto-app-report-overview-tab-a-4" class="view-skills" *ngIf="school?.length" routerLink="/report-details/report-education" [queryParams]="queryParams">View School</a>
            <div class="vectordiv ml-3" *ngIf="school?.length && fieldOfStudy?.length">|</div>
            <a data-testid="auto-app-report-overview-tab-a-5" class="view-titles" *ngIf="fieldOfStudy?.length" routerLink="/report-details/report-education" [queryParams]="queryParams">View Study</a>
        </div>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <div class="loader text-center" *ngIf="!school?.length">
                <img *ngIf="!reportOverViewLoaders.schoolDataFetched" src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
                <span *ngIf="reportOverViewLoaders.schoolDataFetched">No Data Available </span>
            </div>
            <div class="row mb-3" *ngIf="school?.length">
                <div class="col-md-9 f-12 text-9696">
                    Top Colleges
                </div>
                <div class="col f-12 text-9696 d-flex align-items-center">
                    Talent Count
                </div>
            </div>
            <div class="test" *ngFor="let s of school | slice: 0:5">
                <div class="row">
                    <div class="col-md-9 d-grid">
                        <span class="text-truncate">{{s.key | titlecase}}</span>
                    </div>
                    <div class="col font-weight-600"><span class="pointer" (click)="handelRedirection('school', s.key)">{{s.doc_count | number}}</span></div>
                </div>
                <hr class="HR-seperator-in-card mb-4 mx-0">
            </div>
        </div>
        <div class="col">
            <div class="loader text-center" *ngIf="!fieldOfStudy?.length">
                <img *ngIf="!reportOverViewLoaders.fieldOfStudyDataFetched" src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
                <span *ngIf="reportOverViewLoaders.fieldOfStudyDataFetched">No Data Available</span>
            </div>
            <div class="row mb-3" *ngIf="fieldOfStudy?.length">
                <div class="col-md-9 f-12 text-9696">
                    Fields of Study
                </div>
                <div class="col f-12 text-9696">
                    Talent Count
                </div>
            </div>
            <div class="test" *ngFor="let fs of fieldOfStudy | slice: 0:5">
                <div class="row">
                    <div class="col-md-9 d-grid">
                        <span class="text-truncate">{{fs.key | titlecase}}</span>
                    </div>
                    <div class="col font-weight-600"><span class="pointer"
                            (click)="handelRedirection('fieldofstudy', fs.key)">{{fs.doc_count | number}}</span></div>
                </div>
                <hr class="HR-seperator-in-card mb-4 mx-0">
            </div>
        </div>
    </div>

    <hr class="HR-seperator-in-card mb-4">
    <div class="row">
        <div class="col-9">
            <p class="f-16 font-weight-600 mb-4">What are related skills and titles for this talent?</p>
        </div>
        <div class="col-3 text-right">
          <div class="d-flex justify-content-end">
            <a data-testid="auto-app-report-overview-tab-a-6" class="view-skills" *ngIf="skills?.length" routerLink="/report-details/report-skills" [queryParams]="queryParams">View Skills</a>
            <div class="vectordiv ml-3" *ngIf="skills?.length && titles?.length">|</div>
            <a data-testid="auto-app-report-overview-tab-a-7" class="view-titles" *ngIf="titles?.length" routerLink="/report-details/report-titles" [queryParams]="queryParams">View Titles</a>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <div class="loader text-center" *ngIf="!skills?.length">
                <img *ngIf="!reportOverViewLoaders.skillsDataFetched" src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
                <span *ngIf="reportOverViewLoaders.skillsDataFetched">No Data Available</span>
            </div>
            <div class="row mb-3" *ngIf="skills?.length">
                <div class="col-md-9 f-12 text-9696">
                   Top Skills
                </div>
                <div class="col f-12 text-9696">
                    Talent Count
                </div>
            </div>
            <div class="test" *ngFor="let s of skills | slice: 0:5">
                <div class="row">
                    <div class="col-md-9 d-grid">
                        <span class="text-truncate">{{s.key | titlecase}}</span></div>
                    <div class="col font-weight-600"><span class="pointer" (click)="handelRedirection('skills', s.key)">{{s.doc_count | number}}</span></div>
                </div>
                <hr class="HR-seperator-in-card mb-4 mx-0">
            </div>
        </div>
        <div class="col">
            <div class="loader text-center" *ngIf="!titles?.length">
                <img *ngIf="!reportOverViewLoaders.titlesDataFetched" src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
                <span *ngIf="reportOverViewLoaders.titlesDataFetched">No Data Available</span>
            </div>
            <div class="row mb-3" *ngIf="titles?.length">
                <div class="col-md-9 f-12 text-9696">
                   Top Titles
                </div>
                <div class="col f-12 text-9696">
                    Talent Count
                </div>
            </div>
            <div  class="test" *ngFor="let t of titles | slice: 0:5">
                <div class="row">
                    <div class="col-md-9 d-grid">
                        <span class="text-truncate">{{t.key | titlecase}}</span></div>
                    <div class="col font-weight-600 pointer"  (click)="handelRedirection('jobtitle', t.key)">{{t.doc_count | number}}</div>
                </div>
                <hr class="HR-seperator-in-card mb-4 mx-0">
            </div>
        </div>
    </div>
</div>


  <app-insights-joblist [data]="toOpenSliderFromTabSubject.asObservable()" [events]="sendDataToSliderSubject.asObservable()" ></app-insights-joblist>

